export const updateDraftAttributes = (params: {
  attributes: any,
  draft: any,
  imageKeys?: string[]
}) => {
  const {attributes, draft, imageKeys = []} = params

  const draftAttributes = {...attributes}

  for (const key in draft) {
    if (typeof draft[key] === 'string') {
      draftAttributes[key] = draft[key]
    }
  }

  for (const key of imageKeys || []) {
    if (draft[key]?.url) {
      draftAttributes[key] = {
        data: {
          attributes: {
            url: draft[key].url
          }
        }
      }
    }
  }

  return draftAttributes
}